import {
  ASSESSMENT_UX_FORM,
  ASSESSMENT_UX_GUIDE,
} from "../utils/assessmentUxMode";

/**
 * Switch between conversational one-at-a-time flow and multi-question survey form.
 */
export default function AssessmentUxToggle({
  mode = ASSESSMENT_UX_GUIDE,
  onChange,
  dark = false,
  compact = false,
}) {
  const isConversational = mode !== ASSESSMENT_UX_FORM;
  const baseBtn = {
    border: "none",
    cursor: "pointer",
    fontWeight: 700,
    letterSpacing: "0.03em",
    transition: "all 0.15s ease",
    borderRadius: 999,
    padding: compact ? "5px 10px" : "6px 12px",
    fontSize: compact ? 10 : 11,
    whiteSpace: "nowrap",
  };

  const shell = {
    display: "inline-flex",
    alignItems: "center",
    gap: 2,
    padding: 3,
    borderRadius: 999,
    background: dark ? "rgba(255,255,255,0.06)" : "rgba(0,79,115,0.06)",
    border: dark
      ? "1px solid rgba(255,255,255,0.12)"
      : "1px solid rgba(0,79,115,0.14)",
  };

  const active = {
    ...baseBtn,
    background: dark ? "rgba(0,79,115,0.95)" : "#004F73",
    color: "#fff",
  };
  const idle = {
    ...baseBtn,
    background: "transparent",
    color: dark ? "rgba(255,255,255,0.55)" : "rgba(0,79,115,0.7)",
  };

  return (
    <div
      role="group"
      aria-label="Assessment layout"
      style={shell}
      title="Conversational: one question at a time with AI. Survey form: classic form with AI help."
    >
      <button
        type="button"
        style={isConversational ? active : idle}
        aria-pressed={isConversational}
        onClick={() => onChange?.(ASSESSMENT_UX_GUIDE)}
      >
        Conversational
      </button>
      <button
        type="button"
        style={!isConversational ? active : idle}
        aria-pressed={!isConversational}
        onClick={() => onChange?.(ASSESSMENT_UX_FORM)}
      >
        Survey form
      </button>
    </div>
  );
}
